import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Label } from '@bingads-webui-react/primitive';
import { Stack, Checkbox } from '@bingads-webui-react/fabric-control';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { Error } from './error';
import { AdjustmentType, isDataExclusion } from '../adjustment-type';

function getStyles() {
  return {
    deviceChoices: {
      marginBottom: '16px',
      '& div[role=alert]': {
        paddingTop: 5,
      },
    },
  };
}
const device = {
  Computers: 'Computers',
  Smartphones: 'Smartphones',
  Tablets: 'Tablets',
};

const getErrorMessage = (selectedDevices) => {
  if (_.isEmpty(selectedDevices)) return _TL_('Device is required. Select one or more devices.');
  return _TL_('');
};
const stackTokens = { childrenGap: 40 };

export function validateDevices(selectedDevices) {
  return _.isEmpty(getErrorMessage(selectedDevices));
}
function SeasonalityDeviceChoice(props) {
  const {
    classes, i18n, selectedDevices, onSelectedDevicesChanged, showValidationError, adjustmentType
  } = props;

  const errorMessage = useMemo(() => (showValidationError ? i18n.getString(getErrorMessage(selectedDevices)) : ''), [i18n, selectedDevices, showValidationError]);
  const isComputerSelected = useMemo(() => _.contains(selectedDevices, device.Computers), [selectedDevices]);
  const isSmartphoneSelected = useMemo(() => _.contains(selectedDevices, device.Smartphones), [selectedDevices]);
  const isTabletSelected = useMemo(() => _.contains(selectedDevices, device.Tablets), [selectedDevices]);
  return (
    <div className={`device-choices ${classes.deviceChoices}`}>
      <Label id="seasonality-devices-label">
        {i18n.getString(_TL_('Devices'))}
        <HelpPopupInline
          topic={isDataExclusion(adjustmentType) ? 'pop_BA_DataExclusions_Devices' : 'pop_BA_SeasonalityAdjustments_Devices'}
          ariaLabel={i18n.getString(_TL_('Click to learn more about {{item}}', { item: i18n.getString(_TL_('Devices')) }))}
        />
      </Label>
      <Stack
        horizontal
        tokens={stackTokens}
        className="devices-checkbox-container"
      >
        <Checkbox
          className="checkbox-computers"
          onChange={onSelectedDevicesChanged}
          label={i18n.getString(_TL_('Computers'))}
          name={device.Computers}
          defaultChecked
          checked={isComputerSelected}
        />
        <Checkbox
          className="checkbox-mobiles"
          onChange={onSelectedDevicesChanged}
          label={i18n.getString(_TL_('Smartphones'))}
          name={device.Smartphones}
          defaultChecked
          checked={isSmartphoneSelected}
        />
        <Checkbox
          className="checkbox-tablets"
          onChange={onSelectedDevicesChanged}
          label={i18n.getString(_TL_('Tablets'))}
          name={device.Tablets}
          defaultChecked
          checked={isTabletSelected}
        />
      </Stack>
      <Error message={errorMessage} />
    </div>
  );
}

SeasonalityDeviceChoice.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({}).isRequired,
  selectedDevices: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectedDevicesChanged: PropTypes.func.isRequired,
  showValidationError: PropTypes.bool.isRequired,
  adjustmentType: PropTypes.oneOf([AdjustmentType.DataExclusion, AdjustmentType.SeasonalityAdjustment]).isRequired,
};

const Wrapped = _.compose(
  withI18nConsumer,
  Comp => withDefaultStyles(Comp, getStyles)
)(SeasonalityDeviceChoice);

export { Wrapped as SeasonalityDeviceChoice };
